import request from '@/utils/request';
export function postInfoShare(id, data) {
    return request({
        url: `/fund/share/${id}`,
        method: 'post',
        data
    });
}
export function getPrepay(id) {
    return request({
        url: `/fund/info/${id}/prepay`,
        method: 'get'
    });
}
export function getInfoSelf(uuid) {
    return request({
        url: `/fund/info/${uuid}/self`,
        method: 'get'
    });
}
export function getOrder(tradeNo) {
    return request({
        url: `/fund/order/${tradeNo}`,
        method: 'get'
    });
}
export function postOrder(data) {
    return request({
        url: `/fund/order`,
        method: 'post',
        data
    });
}
export function getInfoById(uuid) {
    return request({
        url: `/fund/info/${uuid}?platform=nx`,
        method: 'get'
    });
}
export function getInfoUUIDById(uuid) {
    return request({
        url: `/fund/info/${uuid}/uuid`,
        method: 'get'
    });
}
export function getDonorById(uuid, last_id, size) {
    return request({
        url: `/fund/info/${uuid}/donor?last_id=${last_id}&size=${size}`,
        method: 'get'
    });
}
export function getMyDonorById(uuid) {
    return request({
        url: `/fund/info/${uuid}/my/donor`,
        method: 'get'
    });
}
export function getWithDrawalById(uuid) {
    return request({
        url: `/fund/info/${uuid}/withdrawal`,
        method: 'get'
    });
}
export function getFeedById(uuid) {
    return request({
        url: `/fund/info/${uuid}/feed`,
        method: 'get'
    });
}
export function postFeedById(uuid, data) {
    return request({
        url: `/fund/info/${uuid}/feed`,
        method: 'post',
        data
    });
}
export function getProveById(uuid, last_id) {
    let lastId = last_id || '';
    return request({
        url: `/fund/info/${uuid}/prove?last_id=${lastId}&size=20`,
        method: 'get'
    });
}
export function postProveById(uuid, data) {
    return request({
        url: `/fund/info/${uuid}/prove`,
        method: 'post',
        data
    });
}
export function postReportById(uuid, data) {
    return request({
        url: `/fund/info/${uuid}/report`,
        method: 'post',
        data
    });
}
export function postRefund(data) {
    return request({
        url: `/fund/refund`,
        method: 'post',
        data
    });
}
export function getMine() {
    return request({
        url: `/fund/mine?size=100`,
        method: 'get'
    });
}
export function getPublishInfo() {
    return request({
        url: `/fund/publish-info`,
        method: 'get'
    });
}
export function getHospital(name) {
    return request({
        url: `/fund/hospital?name=${name}`,
        method: 'get'
    });
}
export function getReviewSave(id, data) {
    return request({
        url: `/fund/manage/${id}/review/save`,
        method: 'post',
        data
    });
}
// 获取患者审核的信息
export function getReviewPatient(uuid) {
    return request({
        url: `/fund/manage/${uuid}/review/patient`,
        method: 'get'
    });
}
// 获取收款审核的信息
export function getReviewPayment(uuid) {
    return request({
        url: `/fund/manage/${uuid}/review/payment`,
        method: 'get'
    });
}
export function getPublishStatus() {
    return request({
        url: `/fund/publish-status`,
        method: 'get'
    });
}
export function getPublishCurrent(data) {
    return request({
        url: `/fund/publish-current`,
        method: 'post',
        data
    });
}
export function getFundInfo(uuid) {
    return request({
        url: `/fund/info/${process.env.VUE_APP_APPID}`,
        method: 'get'
    });
}
export function postPublishInfo(data) {
    return request({
        url: `/fund/publish-info`,
        method: 'post',
        data
    });
}
// 智能生成接口
export function postGenStory(data) {
    return request({
        url: `/fund/gen-story`,
        method: 'post',
        data
    });
}
export function postPublishAsset(data) {
    return request({
        url: `/fund/publish-asset`,
        method: 'post',
        data
    });
}
// 提交患者审核
export function postReviewPatient(uuid, data) {
    return request({
        url: `/fund/manage/${uuid}/review/patient`,
        method: 'post',
        data
    });
}
// 提交收款审核
export function postReviewPayment(uuid, data) {
    return request({
        url: `/fund/manage/${uuid}/review/payment`,
        method: 'post',
        data
    });
}
export function postBdNormalClue(data) {
    return request({
        url: `/bd/normal-clue`,
        method: 'post',
        data
    });
}
export function getBindFundById(uuid) {
    return request({
        url: `/bd/bind/fund/${uuid}`,
        method: 'get'
    });
}
export function getRegion() {
    return request({
        url: `/fund/region`,
        method: 'get'
    });
}
export function getInfoCommentById(uuid, data) {
    return request({
        url: `/fund/info/${uuid}/comment?donor_ids=${data.toString()}&entity=donor`,
        method: 'get'
    });
}
export function getDonorExport(uuid) {
    return request({
        url: `/fund/info/${uuid}/donor-export`,
        method: 'get'
    });
}
export function postDonorReply(uuid, data) {
    return request({
        url: `/fund/info/${uuid}/donor/comment`,
        method: 'post',
        data
    });
}
export function getNotify(data) {
    return request({
        url: '/fund/notify/info',
        method: 'post',
        data
    });
}
export function getPoster(params) {
    return request({
        url: '/fund/poster',
        method: 'get',
        params
    });
}
export function getmemberVip(params) {
    return request({
        url: `/member/box`,
        method: 'get',
        params
    });
}
export function postOrderVip(data) {
    return request({
        url: `/member/order`,
        method: 'post',
        data
    });
}
export function postOrderVipzreo(id) {
    return request({
        url: `/member/free/${id}`,
        method: 'get'
    });
}
export function getMemberCenter() {
    return request({
        url: `/member/center`,
        method: 'get'
    });
}
export function getMemberEquityCenter() {
    return request({
        url: `/member/equity/center`,
        method: 'get'
    });
}
export function PostMemberConsume(data) {
    return request({
        url: `/member/consume`,
        method: 'post',
        data
    });
}
export function PostMemberHospital(params) {
    return request({
        url: `/member/hospital`,
        method: 'get',
        params
    });
}
export function PostMemberConsumeOtherl(data) {
    return request({
        url: `/member/consume_other`,
        method: 'post',
        data
    });
}
export function PostMemberOrderl(no) {
    return request({
        url: `/member/order/${no}`,
        method: 'get',
    });
}
export function getDiseaselCategory() {
    return request({
        url: `/fund/disease/category`,
        method: 'get',
    });
}
export function getDonateInfo(id) {
    return request({
        url: `/fund/donate/info/${id}`,
        method: 'get',
    });
}
export function getScreenshot(id, params) {
    return request({
        url: `/fund/video/screenshot/${id}`,
        method: 'get',
        params
    });
}
export function getDonorList(params) {
    return request({
        url: `/fund/info/donor-list`,
        method: 'get',
        params
    });
}
export function getBranchList(params) {
    return request({
        url: `/fund/manage/review/branch`,
        method: 'get',
        params
    });
}
export function getAssistShare(id) {
    return request({
        url: `/fund/assist/share/${id}`,
        method: 'get'
    });
}
export function postAssistShare(id) {
    return request({
        url: `/fund/assist/share/${id}`,
        method: 'post'
    });
}
export function getAccountJump(id) {
    return request({
        url: `/fund/account/Jump/${id}`,
        method: 'get'
    });
}
export function getAccountJumpList() {
    return request({
        url: `/fund/account/Jump/list`,
        method: 'get'
    });
}
export function postFundCardImage(data) {
    return request({
        url: `/fund/card/image`,
        method: 'post',
        data
    });
}
export function postFundBankImage(data) {
    return request({
        url: `/fund/bank/image`,
        method: 'post',
        data
    });
}
export function postBankName(uuid, data) {
    return request({
        url: `fund/manage/${uuid}/review/bank`,
        method: 'post',
        data
    });
}
